<template>
	<div class="app-slider">
		<div
			class="app-slider__label"
			v-if="$slots.default"
		>
			<slot></slot>
		</div>

		<div
			class="app-slider__input-wrapper"
			:class="{'app-slider__input-wrapper--disabled' : $attrs.disabled,
					'app-slider__input-wrapper--error' : error}"
		>
			<p class="app-slider__value">{{ value[0] }} - {{ value[1] }}</p>
			<div ref="slider" class="app-slider__slider"></div>
		</div>

		<p
			v-if="error"
			class="app-slider__error"
		>
			{{ error }}
		</p>
	</div>
</template>

<script>
import noUiSlider from 'nouislider'
import 'nouislider/distribute/nouislider.css'

export default {
	props: {
		value: {
			type: Array,
			default: () => [0, 0]
		},

		error: String
	},

	async mounted () {
		await this.$nextTick()
		this.init()
	},

	watch: {
		value (val) {
			const slider = this.$refs.slider
			slider.noUiSlider.set(val)
		}
	},

	methods: {
		init () {
			let slider = this.$refs.slider
			noUiSlider.create(slider, {
				start: this.value,
				step: Number(this.$attrs.step || 1),
				tooltips: true,
				connect: true,
				format: {
					from: value => Math.trunc(value),
					to: value => Math.trunc(value)
				},
				range: {
					'min': Number(this.$attrs.min || 0),
					'max': Number(this.$attrs.max || 100)
				}
			})

			slider.noUiSlider.on('update', (values) => {
				if (values[0] !== this.value[0] ||
					values[1] !== this.value[1]) {
					this.$emit('input', values)
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.app-slider {
	display: inline-block;
	min-width: 200px;

	&__label {
		color: $default;
		margin-bottom: 6px;
		display: block;
	}

	&__input-wrapper {
		width: 100%;
		display: flex;
		align-items: center;
		position: relative;
		border: 1px solid $default-light;
		padding: 5px 8px;
		border-radius: 3px;
		background-color: #fff;
		color: $default;

		&:hover, &:focus-within {
			border-color: $primary;
		}

		&--disabled {
			pointer-events: none;
			opacity: 0.5;
		}

		&--error {
			border-color: $danger;

			&:hover, &:focus-within {
				border-color: $danger;
			}
		}
	}

	&__value {
		width: 4.5em;
		text-align: center;
		flex-shrink: 0;
	}

  &__slider {
    flex: 1 1 auto;
    margin: 0 12px;
  }

	&__error {
		color: $danger;
		margin-top: .5em;
		display: flex;
		justify-content: flex-end;
	}
}

/deep/ .noUi {
	&-target {
		background: #eee;
		border: none;
	}

	&-horizontal {
		height: 5px;
	}

	&-handle {
		width: 14px;
		height: 14px;
		right: -9px;
		top: -4px;
		cursor: pointer;
		border: 1px solid #eee;
		border-radius: 50%;
		// box-shadow: 0 3px 8px #00000066;
		&:after, &:before {
			display: none;
		}
		&:focus {
			outline: none;
			border-color: $primary;
		}
	}

	&-touch-area {
		background: #fff;
		border-radius: inherit;
	}

	&-tooltip {
		display: none;
	}

	&-active &-tooltip {
		display: block;
	}
}
</style>
